import React, { useRef } from 'react';

import { Icon, IconSize } from '../Icon';
import * as S from './checkbox.styles';
import { CheckboxProps } from './checkbox.types';

import Check from '@/icons/check.icon.svg';

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  disabled = false,
  ...inputProps
}) => {
  const checkboxRef = useRef<HTMLInputElement>(null);

  return (
    <S.Container disabled={disabled} onClick={() => checkboxRef.current?.click()}>
      <S.Checkbox
        tabIndex={1}
        onClick={(e) => {
          e.stopPropagation();
          checkboxRef.current?.click();
        }}
      >
        {checked && <Icon icon={Check} size={IconSize.S} />}
        <input
          {...inputProps}
          checked={checked}
          ref={checkboxRef}
          type="checkbox"
          disabled={disabled}
          style={{ display: 'none' }}
        />
      </S.Checkbox>
      {label && <S.Label>{label}</S.Label>}
    </S.Container>
  );
};
